import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/@/components/ui/table';
import Iconify from 'src/components/Iconify';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function TableScoring({ data, onEdit, onDelete }) {
  const { t } = useTranslation('settings');

  return (
    <Table>
      <TableHeader>
        <TableRow className="border-b border-[#f0f0f3] hover:bg-transparent">
          <TableHead className={`${D.tableHead} px-[26px]`}>{t('labels.name', 'Nome', { ns: 'common' })}</TableHead>
          <TableHead className={D.tableHead}>{t('labels.type', 'Tipo', { ns: 'common' })}</TableHead>
          <TableHead className={D.tableHead}>{t('funnel.scoring.pointsLabel', 'Pontos')}</TableHead>
          <TableHead className={D.tableHead}>{t('labels.status', 'Status', { ns: 'common' })}</TableHead>
          <TableHead className={`${D.tableHead} w-[100px] text-right px-[26px]`} />
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((row, index) => (
          <TableRow key={index} className={D.tableRow}>
            <TableCell className={`${D.tableCell} font-medium px-[26px]`}>{row.name}</TableCell>
            <TableCell>
              <span className={`${D.badge} ${row.type === 'credit' ? D.badgeOk : 'bg-[#fef3f2] text-[#b42318] border-[#fecdca]'}`}>
                {row.type === 'credit'
                  ? t('funnel.scoring.table.creditLabel', 'Crédito')
                  : t('funnel.scoring.table.debitLabel', 'Débito')}
              </span>
            </TableCell>
            <TableCell className={D.tableCell}>{row.points}</TableCell>
            <TableCell>
              <span className={`${D.badge} ${row.status === 'true' ? D.badgeOk : D.badgeNeutral}`}>
                <span className={`${D.badgeDot} ${row.status === 'true' ? D.badgeDotOk : D.badgeDotNeutral}`} />
                {row.status === 'true'
                  ? t('status.active', 'Ativo', { ns: 'common' })
                  : t('status.inactive', 'Inativo', { ns: 'common' })}
              </span>
            </TableCell>
            <TableCell className="px-[26px]">
              <div className="flex gap-1.5 justify-end">
                <button type="button" onClick={() => onEdit(row)} className={D.iconButton}>
                  <Iconify icon="eva:edit-2-outline" width={14} />
                </button>
                <button type="button" onClick={() => onDelete(row)} className={D.iconButtonDanger}>
                  <Iconify icon="eva:trash-2-outline" width={14} />
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
